const Atinternet = () => {

    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
    window._adftrack.push({
        HttpHost: 'server.adform.net',
        pm: 2867417,
        divider: encodeURIComponent('|'),
        pagename: encodeURIComponent('2023-02-choisirleservicepublic.gouv.fr-PageAccueil-PageChoisirLeServicePublic')
    });
    
    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();

    // default

    const at_internet_code = document.body.getAttribute('data-at-internet');

    if (!window.pa) { return; }

    pa.setConfigurations({
        'site': at_internet_code,
        'collectDomain': "https://logs1412.xiti.com",
    });

    const user_id = document.querySelector('#user_id').value;
    const user_type = document.querySelector('#user_type').value;
    const level_1 = document.querySelector('#level_1').value;
    const level_2 = document.querySelector('#level_2').value;
    const level_3 = document.querySelector('#level_3').value;
    const page_name = document.querySelector('#page_name').value;
    const page_type = document.querySelector('#page_type').value;

    pa.setProperties({
        'page': page_name, 
        'page_chapter1': level_1,
        'page_chapter2': level_2,
        'page_chapter3': level_3,
        'page_type': page_type,
        'user_id' : user_id,
        'user_category' : user_type,
        'accessibility': [],
    },{
        'persistent': true,
    });

    pa.sendEvent('page.display', {});

    // clicks
    const clickEvents = document.querySelectorAll('[data-at-click]');
    clickEvents.forEach((el) => {
        el.addEventListener('click', (e) => {

            if (el.tagName == "A" && el.target !== "_blank") {
                e.preventDefault();
            }

            const data = el.getAttribute('data-at-click');
            sendEvent(data);

            if (el.tagName == "A" && el.target !== "_blank") {
                document.location = el.href;
            }
        });
    });

    // const actusClickEvents = document.querySelectorAll('body .strates a:not([data-at-click])');
    // actusClickEvents.forEach((el) => {
    //     el.addEventListener('click', (e) => {

    //         if (el.tagName == "A" && el.target !== "_blank") {
    //             e.preventDefault();
    //         }

    //         const data = '{"event":"click.exit","data":{"click" : "' + el.innerText + '","click_chapter1" : "Actualites","click_chapter2" : "Details actualites","event_general_placement" : "Body" }}';
    //         sendEvent(data);

    //         if (el.tagName == "A" && el.target !== "_blank") {
    //             document.location = el.href;
    //         }
    //     });
    // });

    const links = document.querySelectorAll('body .strates a:not([data-at-click])');
    links.forEach((el) => {
        el.addEventListener('click', (e) => {
            if (el.tagName == "A" && el.target !== "_blank") {
                e.preventDefault();
            }

            const type = (el.target == "_blank") ? "click.exit" : "click.navigation";
            const data = '{"event":"' + type + '","data":{"click" : "' + el.innerText.replace(/\n/,' ') + '","click_chapter1" : "' + level_1 + '","click_chapter2" : "' + level_2 + '","event_general_placement" : "Body" }}';
            sendEvent(data);

            if (el.tagName == "A" && el.target !== "_blank") {
                document.location = el.href;
            }
        });
    });

    function sendEvent(data) {
        const json = JSON.parse(data);
        pa.sendEvent(json.event, json.data);
    }


    // var firstFolder = "";
    // var pathArray = window.location.pathname.split('/');

    // atInternetScript.onload = function () {
    //     var tag = new ATInternet.Tracker.Tag();
    //     tag.privacy.setVisitorMode('cnil', 'exempt');
    //     tag.privacy.extendIncludeBuffer('s2');

    //     if (pathArray.length > 1) {
    //         var firstFolder = pathArray[1];
            
    //         if (firstFolder == "nos-offres") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 24
    //             });
    //             tag.dispatch();
    //         } else if (firstFolder == "passer-un-concours") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 25
    //             });
    //             tag.dispatch();
    //         } else if (firstFolder == "employeurs") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 26
    //             });
    //             tag.dispatch();
    //         } else if (firstFolder == "metiers") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 27
    //             });
    //             tag.dispatch();
    //         } else if (firstFolder == "conseils") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 28
    //             });
    //             tag.dispatch();
    //         } else if (firstFolder == "actualites") {
    //             tag.page.set({
    //                 name: document.title,
    //                 level2: 29
    //             });
    //             tag.dispatch();
    //         } else {
    //             tag.page.set({
    //                 name: document.title,
    //             });
    //             tag.dispatch();
    //         }
    //     } else {
    //         tag.page.set({
    //             name: document.title,
    //         });
    //         tag.dispatch();
    //     }

    // };

};

export default Atinternet;